var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form_box" }, [
      _c("div", { staticClass: "form_item" }, [
        _c("img", {
          staticClass: "form_icon",
          attrs: {
            src: require("../../assets/img/h5_login_mailbox.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.account,
              expression: "account"
            }
          ],
          staticClass: "form_input",
          attrs: { type: "text", placeholder: _vm.$t("m.input_email") },
          domProps: { value: _vm.account },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.account = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form_item" }, [
        _c("img", {
          staticClass: "form_icon",
          attrs: {
            src: require("../../assets/img/h5_login_password.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        (_vm.isPassword ? "password" : "text") === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "form_input",
              attrs: {
                placeholder: _vm.$t("m.input_password"),
                type: "checkbox"
              },
              domProps: {
                checked: Array.isArray(_vm.password)
                  ? _vm._i(_vm.password, null) > -1
                  : _vm.password
              },
              on: {
                change: function($event) {
                  var $$a = _vm.password,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.password = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.password = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.password = $$c
                  }
                }
              }
            })
          : (_vm.isPassword ? "password" : "text") === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "form_input",
              attrs: { placeholder: _vm.$t("m.input_password"), type: "radio" },
              domProps: { checked: _vm._q(_vm.password, null) },
              on: {
                change: function($event) {
                  _vm.password = null
                }
              }
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "form_input",
              attrs: {
                placeholder: _vm.$t("m.input_password"),
                type: _vm.isPassword ? "password" : "text"
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            }),
        _vm._v(" "),
        _c("img", {
          staticClass: "sendcode_img",
          attrs: {
            src: _vm.isPassword
              ? require("../../assets/img/h5_login_eye01.png")
              : require("../../assets/img/h5_login_eye02.png")
          },
          on: {
            click: function($event) {
              _vm.isPassword = !_vm.isPassword
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fc-bind-btn",
          class: { active: _vm.formIsTrue },
          on: { click: _vm.goLogin }
        },
        [_vm._v(_vm._s(_vm.$t("m.login")))]
      )
    ]),
    _vm._v(" "),
    !_vm.isTgWebApp
      ? _c("div", { staticClass: "login_box" }, [
          _c(
            "div",
            { staticClass: "login_other" },
            [
              !_vm.isInRealLive
                ? _c("login-sdk-facebook", { attrs: { styleType: "circle" } })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isInRealLive
                ? _c("login-sdk-google", { attrs: { styleType: "circle" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.thisLangcountry !== "zh" && !_vm.isInRealLive
                ? _c("login-sdk-twitter")
                : _vm._e(),
              _vm._v(" "),
              _vm.thisLangcountry == "ru" && !_vm.isInRealLive
                ? _c("login-sdk-vk")
                : _vm._e(),
              _vm._v(" "),
              _vm.thisLangcountry !== "zh" && !_vm.isInRealLive
                ? _c("login-sdk-instagram")
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "img_box", on: { click: _vm.phoneLogin } },
                [
                  _c("img", {
                    staticClass: "login_other_img",
                    attrs: {
                      src: require("../../assets/img/h5_login_icon05.png")
                    }
                  })
                ]
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1efbc82e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1efbc82e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginEmail.vue
// module id = null
// module chunks = 